import { CheckinOrderFragment, CheckoutOrderFragment } from '@websky/graphql';

import { CartServiceProps } from '../Cart/types';

export const isCheckoutOrder = (
	order: CheckoutOrderFragment | CheckinOrderFragment
): order is CheckoutOrderFragment => {
	return (order as CheckoutOrderFragment).flight !== undefined;
};

export const convertCartServiceProps = (order: CheckoutOrderFragment | CheckinOrderFragment): CartServiceProps => {
	if (isCheckoutOrder(order)) {
		return {
			flight: order.flight,
			customer: order.customer,
			travellers: order.travellers,
			services: order.additionalServices
		};
	}

	return {
		flight: {
			seatMap: order.seatMap,
			segments: order.segments.map(segment => ({
				segment: {
					...segment,
					stops: [],
					messages: []
				},
				transferDuration: null
			})),
			segmentGroups: [],
			fares: []
		},
		customer: order.customer as CheckoutOrderFragment['customer'],
		travellers: order.travellers.map(passenger => ({
			...(passenger as CheckoutOrderFragment['travellers'][0]),
			tickets: passenger.tickets?.map(ticket => ({
				...ticket,
				issueDate: '',
				coupons: []
			})),
			services: {
				...passenger.services,
				brandIncludedServices: { services: [] }
			},
			supplierTravellerType: null,
			needOthsSsr: null,
			subsidyInfo: null,
			fares: null
		})),
		services: order.additionalServices
	};
};
